module.exports = __webpack_public_path__ + "img/9a0a7be.png";